<template>
  <div @click="changeSort" class="sort-container">
    <u>
      <slot/>
    </u>
    <md-icon v-if="sort.field===field && sort.ascending">keyboard_arrow_up</md-icon>
    <md-icon v-if="sort.field===field && !sort.ascending">keyboard_arrow_down</md-icon>
  </div>
</template>

<style>
  .sort-container {
    cursor: pointer;
  }
</style>

<script>

  export default {
    props: {
      field: String,
      sort: Object,
    },
    computed: {
      getSortIcon() {
        return this.sort.ascending === true ? 'keyboard_arrow_up' : 'keyborad_arrow_down'
      },
    },
    methods: {
      changeSort() {
        if (this.sort.field !== this.field) {
          this.sort.field = this.field;
          this.sort.ascending = true;
        } else {
          this.sort.ascending = !this.sort.ascending;
        }
      }
    },

  }

</script>
